import React from "react";
import Clipboard from "clipboard";

class CopiarURL extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  componentDidMount() {
    // Inicializamos la librería clipboard al montar el componente
    this.clipboard = new Clipboard(".copy-button", {
      text: () => "https://cantirondas.com/videopersonalizado/",
    });

    this.clipboard.on("success", () => {
      // Cuando la copia es exitosa, actualizamos el estado para mostrar el mensaje
      this.setState({ copied: true });

      this.props.setIsCopied(true);

      // Después de un tiempo (por ejemplo, 2 segundos), ocultamos el mensaje
      setTimeout(() => this.setState({ copied: false }), 2000);
    });

    this.clipboard.on("error", () => {
      // Manejar errores si la copia falla (esto puede depender del navegador o permisos)
      console.error("No se pudo copiar el URL.");
    });
  }

  componentWillUnmount() {
    // Limpiamos los event listeners al desmontar el componente
    this.clipboard.destroy();
  }

  copyToClipboard() {
    // Invocamos el evento de click del botón cuando se quiera copiar
    this.clipboard.onClick({ trigger: document.querySelector(".copy-button") });
  }

  render() {
    const { variant } = this.props;
    return (
      <div>
        <img
          className="copy-button"
          onClick={this.copyToClipboard}
          src={`${
            variant === 2
              ? "/assets/error_chorme/copiar_blue.png"
              : "/assets/error_chorme/copiar_rosa.png"
          }`}
          alt=""
        />
      </div>
    );
  }
}

export default CopiarURL;
